<template>
  <b-card
    no-body
    class="p-2"
  >
    <h3 class="mb-2">
      Editar Requerimiento documento tipo
    </h3>
    <validation-observer
      #default="{ handleSubmit }"
      ref="refFormObserver"
    >
      <b-form
        @submit.prevent="handleSubmit(onSubmit)"
        @reset.prevent="resetForm"
      >
        <b-row>
          <!-- name Field -->
          <b-col
            cols="12"
            md="4"
          >
            <validation-provider
              #default="{ errors }"
              name="nombre"
              rules="required"
            >
              <b-form-group
                label="Nombre"
                :state="errors.length > 0 ? false:null"
              >
                <b-form-input
                  v-model="requirementDocumentType.nombre"
                />
                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-button
          variant="primary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          type="submit"
        >
          {{ $t('Lists.saveChanges') }}
        </b-button>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BCard,
  BForm,
  BRow,
  BCol,
  BFormInput,
  BFormGroup,
  // BFormTextarea,

  BFormInvalidFeedback,
  BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import actionsImprovement from '@/services/actionsImprovement.service'
import { ref } from '@vue/composition-api'
import router from '@/router'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'

export default {
  components: {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormInput,
    BFormInvalidFeedback,
    BFormGroup,
    BButton,
    // Form Validation
    ValidationProvider,
    ValidationObserver,

  },
  setup() {
    /* SERVICES */
    const {
      fetchRequirementDocumentType,
      updateRequirementDocumentType,
    } = actionsImprovement()

    // Data
    const requirementDocumentType = ref({})
    fetchRequirementDocumentType(router.currentRoute.params, data => {
      requirementDocumentType.value = data
    })
    /* Events */
    const onSubmit = () => {
      updateRequirementDocumentType(requirementDocumentType.value)
        .then(() => {
          router.push({ name: 'apps-requirement-document-type-list' })
        })
    }
    /* Validations */
    const requirementDocumentTypeData = ref(JSON.parse(JSON.stringify(requirementDocumentType.value)))
    const resetrequirementDocumentTypeData = () => {
      requirementDocumentTypeData.value = JSON.parse(JSON.stringify(requirementDocumentType))
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetrequirementDocumentTypeData)
    return {
      // Data
      requirementDocumentType,
      /* Events */
      onSubmit,
      // Validations
      required,
      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>

<style>

</style>
